<i ng-if="vm.outdated"
   class="fa fa-exclamation-triangle"
   uib-tooltip="{{'REPORT.TEMPLATE.OUTDATED' | translate: {
   current: vm.reportTemplate.templateVersion,
   new: vm.reportState.templateVersion} }}">
</i>
